import MuiStack, { StackProps as MuiStackProps } from '@mui/material/Stack';
import * as React from 'react';

export interface StackProps extends MuiStackProps {
  component?: React.ElementType;
  /** @default 1 */
  spacing?: MuiStackProps['spacing'];
}

export const Stack = (props: StackProps) => {
  return (
    <MuiStack data-testid={'stack'} spacing={1} {...props}>
      {props.children}
    </MuiStack>
  );
};
